// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import $            from 'jquery';

export default class Oauth2BrianLogin extends WebComponent {
	didMount() {
		const {
				authUrl,
				msgCont,
		} = this.props;


		if (window.location.hash.indexOf("#") === 0) {
			this.sendHash({
				hashFull: window.location.hash,
				hash: window.location.hash.substr(1)
			});
		} else {
			if (debug) {
				console.log("Hash does not exist!");
			}
			let msg = $('#'+msgCont);
			msg.html('Přihlášení se nezdařilo! <a class="btn logging--btn" href="'+authUrl+'">Opakovat</a>');
		}

	}

	sendHash(e) {
		const {
				authUrl,
				loginUrl,
				method,
				fullhash,
				msgCont,
				debug,
		} = this.props;

		let hash;

		if (fullhash) {
			hash = e.hashFull;
		} else {
			hash = e.hash;
		}

		let data = {
			"url": hash
		};

		if (debug) {
			console.log("Debug msg:");
			console.log(debug);
			console.log("Event data:");
			console.log(e);
			console.log("GET URL:");
			console.log(loginUrl + "?url=" + hash);
			console.log("JSON data:");
			console.log(data);
			console.log("Serialized representation of an a plain object:");
			console.log($.param(data, true));
		}

		if (method === 'POST' || method === 'GET') {

			var request = $.ajax({
				url: loginUrl,
				method: method,
				contentType: "application/json",
				data: JSON.stringify(data),
				dataType: "json"
			});

			request.done(function (data) {
				if (data.redirect) {
					if (debug) {
						console.log("Redirecting...");
						console.log(data);
					}
					window.location.href = data.redirect;
				} else {
					if (debug) {
						console.log("Redirection did not occur due to missing redirect URL.");
						console.log(data);
					}
					window.location.href = "/";
				}
			});

			request.fail(function (jqXHR, textStatus) {
				if (debug) {
					console.log("Request failed:");
					console.log(textStatus);
					console.log(jqXHR.responseJSON);
				}
				let err = jqXHR.responseJSON.error;
				let msg = $('#'+msgCont);
				if(err.code === '403') {
					msg.html('Přihlášení se nezdařilo!<br>'+err.message+' <a class="btn logging--btn" href="'+authUrl+'">Opakovat</a>');
				} else {
					msg.html('Přihlášení se nezdařilo! <a class="btn logging--btn" href="'+authUrl+'">Opakovat</a>');
				}
			});

		} else if (method === 'WINDOW') {
			window.location.assign(loginUrl + "?" + $.param(data, true));
		} else {
			console.log("The HTTP method to use for the request not valid!");
		}


	}

}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/Oauth2BrianLogin.js